// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { useMemo } from "react";

// Images

function Header({ user }) {
  const getAvatar = useMemo(() => {
    let avatar = "";
    if (user) {
      if (user.firstName && user.firstName.length) {
        avatar += user.firstName[0];
      }
      if (user.lastName && user.lastName.length) {
        avatar += user.lastName[0];
      }
    }
    return avatar;
  }, [user]);
  return (
    <Card id="profile">
      <MDBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar bgColor="info" size="xl" shadow="sm">
              {getAvatar}
            </MDAvatar>
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              {user && (
                <MDTypography variant="h5" fontWeight="medium">
                  {user.firstName} {user.lastName}
                </MDTypography>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
Header.defaultProps = {
  user: {},
};

Header.propTypes = {
  user: PropTypes.shape(),
};
export default Header;
